import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
import router from "@/router";
import InlineSvg from "vue-inline-svg";
import { useUserStore } from "@/stores/userStore";
import Page from "@/components/shared/Page.vue";
import CompanyInfo from "@/components/mypage/CompanyInfo.vue";
import { BookRequiredType, RouterName, TermsTypeCode } from "@/types";
import { ITermsInfo } from "@/domain/entities/serviceInfo/termsInfo";
import { useServiceStore } from "@/stores/serviceStore";
import TermsDetail from "@/components/signup/TermsDetail.vue";
import { useLineStore } from "@/stores/lineStore";
import ScrollTopControl from "@/components/shared/ScrollTopControl.vue";
import PageModal from "@/components/shared/modal/base/PageModal.vue";


const __default__ = {
  name: "MyPage",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["toggleShowMenu"],
  setup(__props, { expose: __expose }) {
  __expose();

_useCssVars(_ctx => ({
  "7ec761a5-logoutBtnBottomMargin": (logoutBtnBottomMargin.value)
}))



const serviceStore = useServiceStore();
const lineStore = useLineStore();
const bookRequiredType = computed(() => lineStore.getBookRequiredType());
const userStore = useUserStore();

const busStopLayouts = computed(
  () => serviceStore.serviceInfo?.busStopLayouts ?? []
);

const scrollContainerRef = ref<HTMLElement>();

/** 사원번호 */
const alias = computed(() => userStore.userInfo?.alias);

const serviceInfo = computed(() => serviceStore.serviceInfo);
const isPublicLineApi = computed(() => serviceInfo.value?.isPublicLineApi);
const isPublicTalkApi = computed(() => serviceInfo.value?.isPublicTalkApi);

const logoutBtn = ref<HTMLElement>();
const logoutBtnBottomMargin = computed(() => {
  const margin =
    window.innerHeight -
    (logoutBtn.value?.getBoundingClientRect().bottom ?? 0) -
    184;

  return margin < 0 ? "22px" : `${margin}px`;
});

const goToMainLogout = () => {
  userStore.logout();
  lineStore.clearFavoriteLines();
  router.push({
    name:
      isPublicLineApi.value || isPublicTalkApi.value
        ? RouterName.MainLogout
        : RouterName.Login,
  });
};

const onClickBack = () => {
  router.currentRoute.value.meta.willGoBack = true;
  router.back();
};

/** 약관 */
const termsList = ref<ITermsInfo[]>([]);
const selectedTerms = ref<ITermsInfo>();
const shouldShowTerms = ref(false);

const getTermsList = () => {
  termsList.value = serviceStore.termsList;
};

const onClickTerms = (code: TermsTypeCode) => {
  selectedTerms.value = termsList.value?.find((terms) => terms.code === code);
  toggleShowTerms(true);
};

const toggleShowTerms = (show: boolean) => {
  shouldShowTerms.value = show;
};

onMounted(() => {
  getTermsList();
});

const __returned__ = { serviceStore, lineStore, bookRequiredType, userStore, busStopLayouts, scrollContainerRef, alias, serviceInfo, isPublicLineApi, isPublicTalkApi, logoutBtn, logoutBtnBottomMargin, goToMainLogout, onClickBack, termsList, selectedTerms, shouldShowTerms, getTermsList, onClickTerms, toggleShowTerms, get InlineSvg() { return InlineSvg }, Page, CompanyInfo, get BookRequiredType() { return BookRequiredType }, get RouterName() { return RouterName }, TermsDetail, ScrollTopControl, PageModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})